import * as SentryAngular from '@sentry/angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
    DEFAULT_CURRENCY_CODE,
    enableProdMode,
    ErrorHandler,
    importProvidersFrom,
    inject,
    isDevMode,
    provideAppInitializer
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
    PreloadAllModules,
    provideRouter,
    RouteReuseStrategy,
    withPreloading,
    withRouterConfig
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';

import { provideGoogleMapsServices } from '@guardfinder/address';
import {
    AppInitService,
    OwnHttpInterceptor,
    provideApiClient,
    provideEventTypes,
    provideGeoLocationService
} from '@guardfinder/shared';

import { provideNgxStripe } from 'ngx-stripe';

import { AppComponent } from './app/app.component';
import { provideAnalytics } from './app/providers/analytics.provider';
import { routes } from './app/routes/webform.routes';
import { Globals } from './app/shared/globals';
import { environment } from './environments/environment';
import { initSentry, provideSentry } from './sentry.provider';

if (environment.production) {
    enableProdMode();
    if (window) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        window.console.log = function () {};
    }
}

initSentry();

export function initializeApp1(appInitService: AppInitService) {
    if (!isDevMode && 'serviceWorker' in navigator) {
        navigator.serviceWorker.register('/ngsw-worker.js');
    }
    return appInitService.Init('client');
}

export function loadStorage(storage: Storage) {
    return storage;
}

bootstrapApplication(AppComponent, {
    providers: [
        { provide: 'environment', useValue: environment },
        { provide: 'globals', useClass: Globals },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'USD' },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.production
        }),
        importProvidersFrom(IonicStorageModule.forRoot()),
        provideAppInitializer(() => initializeApp1(inject(AppInitService))),
        {
            provide: 'storage',
            useFactory: loadStorage,
            deps: [Storage]
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OwnHttpInterceptor,
            multi: true
        },
        provideIonicAngular({
            mode: 'md'
        }),
        provideRouter(
            routes,
            withPreloading(PreloadAllModules),
            withRouterConfig({ paramsInheritanceStrategy: 'always' })
        ),
        provideHttpClient(withInterceptorsFromDi()),
        provideApiClient(),
        provideAnimations(),
        {
            provide: ErrorHandler,
            // Attach the Sentry ErrorHandler
            useValue: SentryAngular.createErrorHandler()
        },
        provideNgxStripe(import.meta.env['NG_APP_STRIPE_KEY']),
        provideGoogleMapsServices(environment.googleMapsApiKey),
        provideGeoLocationService(),
        provideEventTypes(),
        provideSentry(),
        provideAnalytics()
    ]
});
